import HeadersModel, { HeaderForm, HeadersFilters } from "../models/headers.model";
import { HeaderType } from "../types/headers";
import { useReducerAsState } from "./useReducerAsState";

interface State {
    loading: boolean;
    error: string;
    headers: Array<HeaderType>;
    header: HeaderType | null;
    totalHeaders: number;
}

const useHeaders = () => {
    const [state, setState] = useReducerAsState<State>({
        loading: false,
        error: "",
        header: null,
        headers: [],
        totalHeaders: 0,
    });

    const { header, headers, totalHeaders, loading, error } = state;

    const fetchHeaders = async (filters: HeadersFilters) => {
        setState({ loading: true, error: "" })
        const response = await HeadersModel.getAll(filters);
        if(response.error){
            setState({loading: false, error: response.error, headers: [], totalHeaders : 0})
            return;
        }

        setState({loading: false,error: "", headers: response.headers?.data, totalHeaders: response.total});
    }

    const saveHeader = async (data: HeaderForm): Promise<boolean> => {
        setState({ loading: true, error: "" })
        const response = await HeadersModel.saveHeader(data);
        if(response.error){
            setState({loading: false, error: response.error})
            return false;
        }

        setState({loading: false,error: ""});
        return true
    }

    const findHeader = async (itemId: number) => {
        setState({ loading: true, error: "" })
        const response = await HeadersModel.find(itemId);
        if(response.error){
            setState({loading: false, error: response.error, header: null})
            return;
        }

        setState({loading: false,error: "", header: response.headers?.data[0]});
    }

    return {
        loading,
        headers,
        header,
        error,
        totalHeaders,
        findHeader,
        fetchHeaders,
        saveHeader
    }
}

export default useHeaders;